/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CompetitionLeagueCreate
 */
export interface CompetitionLeagueCreate {
    /**
     * 
     * @type {string}
     * @memberof CompetitionLeagueCreate
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof CompetitionLeagueCreate
     */
    created_at?: Date;
}

/**
 * Check if a given object implements the CompetitionLeagueCreate interface.
 */
export function instanceOfCompetitionLeagueCreate(value: object): value is CompetitionLeagueCreate {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CompetitionLeagueCreateFromJSON(json: any): CompetitionLeagueCreate {
    return CompetitionLeagueCreateFromJSONTyped(json, false);
}

export function CompetitionLeagueCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompetitionLeagueCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'created_at': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
    };
}

export function CompetitionLeagueCreateToJSON(json: any): CompetitionLeagueCreate {
    return CompetitionLeagueCreateToJSONTyped(json, false);
}

export function CompetitionLeagueCreateToJSONTyped(value?: CompetitionLeagueCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'created_at': value['created_at'] == null ? undefined : ((value['created_at']).toISOString()),
    };
}

